// import React from "react";
// import Table from "mui-datatables";
// import styled from "styled-components/macro";
// import { get } from "lodash";

// const MUIDataTable = styled(Table)`
//   .MuiTableCell-head {
//     text-transform: capitalize;
//     background: ${({ theme }) => {
//       return theme.palette.background.default;
//     }};
//   }

//   .MuiTableHead-root {
//     background: #32bcad;
//   }

//   .MuiTableCell-body {
//     cursor: ${(props) =>
//       Boolean(
//         get(props, "options.onRowClick") || get(props, "options.onCellClick")
//       )
//         ? "pointer"
//         : ""};
//   }
// `;

// export default function DataTable(props) {
//   const options = {
//     selectableRows: "none",
//     rowsPerPageOptions: [10, 25, 50, 100],
//     enableNestedDataAccess: ".",
//     elevation: 1,
//     responsive: "simple",
//     tableBodyMaxHeight: "100vh",
//     sortOrder: {
//       name: "created_at",
//       direction: "desc",
//     },
//   };

//   return (
//     <React.Fragment>
//       <MUIDataTable {...props} options={{ ...options, ...props.options }} />
//     </React.Fragment>
//   );
// }

import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: "none",
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#32bcad",
    textTransform: "capitalize",
    color: "#fff",
    fontWeight: 600,
  },
  "& .MuiDataGrid-cell": {
    cursor: "default",
  },
}));

export default function DataTable({
  columns = [],
  data = [],
  onRowClick,
  pageSize = 10,
  rowsPerPageOptions = [10, 25, 50, 100],
  ...props
}) {
  const handleRowClick = (params) => {
    if (onRowClick) {
      onRowClick(params.row);
    }
  };

  const formattedColumns = columns.map((col) => ({
    ...col,
    flex: col.flex || 1,
    sortable: col.sortable !== false,
  }));

  const formattedRows = data.map((row, index) => ({
    id: row.id || index, // DataGrid requires a unique 'id'
    ...row,
  }));

  return (
    <StyledDataGrid
      rows={formattedRows}
      columns={formattedColumns}
      pageSize={pageSize}
      rowsPerPageOptions={rowsPerPageOptions}
      onRowClick={handleRowClick}
      disableSelectionOnClick
      autoHeight
      sortingOrder={["desc", "asc"]}
      {...props}
    />
  );
}
